// This mixin introduces a date filter

import moment from 'moment'

const DEFAULT_FORMAT = 'YYYY-MM-DD'

// @vue/component
export default {
  filters: {
    // Returns formatted date
    date: (date, language = 'en') => moment(date).locale(language).format(DEFAULT_FORMAT)
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/dashboard/widgets/widgets/mixins/WidgetDateMixin.js